import { render, staticRenderFns } from "./GridFamilyDots.vue?vue&type=template&id=4fbb329e&scoped=true"
import script from "./GridFamilyDots.vue?vue&type=script&lang=js"
export * from "./GridFamilyDots.vue?vue&type=script&lang=js"
import style0 from "./GridFamilyDots.vue?vue&type=style&index=0&id=4fbb329e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fbb329e",
  null
  
)

export default component.exports